import ReactGA from "react-ga";
import gsap from 'gsap';

import { StrictMode, useEffect, } from "react";
import { WagmiProvider, } from "wagmi";
import { useGSAP } from "@gsap/react";

import { ApolloProvider, } from "@apollo/client";
import { CrashScreen, handleWalletConnectRecovery, patchConsole, } from "@bracket/catch";
import { initializeTheme, themed, ErrorBoundary, ModalProvider, StyleProvider } from "@bracket/ui";
import { NotificationManager, } from "@bracket/platform/components";
import { version, } from "@bracket/platform/config";

import { QueryClient, QueryClientProvider, } from "@tanstack/react-query";
import { apolloClient, wagmiConfig, } from "@bracket/platform/wagmiconfig";
import { AccessControlProvider, } from "client/AccessControlProvider";


import { AppRouter, } from "./routing/AppRouter";

gsap.registerPlugin(useGSAP)

const queryClient = new QueryClient();
patchConsole();

export const App = () => {
	themed();

	console.log(`starting @bracket/platform on version v${version}`);

	useEffect(() => {
		initializeTheme();
		ReactGA.initialize("G-10K1M7P99V");
	}, []);

	useEffect(() => {

		const cleanup = () => {
			( async () => {
				const { useStore, } = await import("@store");
				const state = useStore.getState();
				state.wallet.cleanup();
			} )();
		};

		globalThis.addEventListener("beforeunload", cleanup);
		globalThis.addEventListener("pagehide", cleanup);

		return () => {
			globalThis.removeEventListener("beforeunload", cleanup);
			globalThis.removeEventListener("pagehide", cleanup);
			cleanup();
		};
	}, []);

	return (
		<StrictMode>
			<ErrorBoundary
				fallback={(error, errorInfo, reset) => (
					<CrashScreen error={error} errorInfo={errorInfo} resetError={reset} boundry={true} />
				)}
				onError={async (error, errorInfo) => {
					console.error("Application error caught:", error, errorInfo);
					await handleWalletConnectRecovery();
				}}
				errorMessage="The Bracket platform encountered an error"
			>
				<ApolloProvider client={apolloClient}>
					<WagmiProvider config={wagmiConfig}>
						<QueryClientProvider client={queryClient}>
							<StyleProvider>
								<ModalProvider>
									<AccessControlProvider >
										<AppRouter />
										<NotificationManager />
									</AccessControlProvider>
								</ModalProvider>
							</StyleProvider>
						</QueryClientProvider>
					</WagmiProvider>
				</ApolloProvider>
			</ErrorBoundary>
		</StrictMode>
	);
};
